import * as yup from 'yup';
import { yupRequiredNonEmptyString } from '../utils/yupRequiredNonEmptyString';

// GPS coordinates validation constants
const MIN_GPS_LATITUDE = -90;
const MAX_GPS_LATITUDE = 90;
const MIN_GPS_LONGITUDE = -180;
const MAX_GPS_LONGITUDE = 180;
const GPS_BOUNDARY_TOLERANCE = 0.001; // Threshold for suspecting boundary-snapped values

export const AlleySchema = yup.object().shape({
  id: yupRequiredNonEmptyString('ID'),
  collectionID: yupRequiredNonEmptyString('Collection ID'),
  objectVersion: yupRequiredNonEmptyString('Object version'),
  startTime: yupRequiredNonEmptyString('Start time'),
  endTime: yupRequiredNonEmptyString('End time'),
  junk: yup.boolean().required('Junk flag is required'),
  alley: yupRequiredNonEmptyString('Alley name'),
  notes: yup.string().nullable(),
  isPassive: yup.boolean().required('Is passive flag is required'),
  fileName: yupRequiredNonEmptyString('File name'),

  minGpsLatitude: yup
    .number()
    .required('Min GPS latitude is required')
    .min(
      MIN_GPS_LATITUDE,
      `Min latitude must be greater than ${MIN_GPS_LATITUDE}`
    )
    .max(MAX_GPS_LATITUDE, `Min latitude must be less than ${MAX_GPS_LATITUDE}`)
    .test(
      'not-boundary-value',
      'GPS value at exact minimum boundary - possible sensor issue',
      (value) => !(Math.abs(value - MIN_GPS_LATITUDE) < GPS_BOUNDARY_TOLERANCE)
    ),

  minGpsLongitude: yup
    .number()
    .required('Min GPS longitude is required')
    .min(
      MIN_GPS_LONGITUDE,
      `Min longitude must be greater than ${MIN_GPS_LONGITUDE}`
    )
    .max(
      MAX_GPS_LONGITUDE,
      `Min longitude must be less than ${MAX_GPS_LONGITUDE}`
    )
    .test(
      'not-boundary-value',
      'GPS value at exact minimum boundary - possible sensor issue',
      (value) => !(Math.abs(value - MIN_GPS_LONGITUDE) < GPS_BOUNDARY_TOLERANCE)
    ),

  maxGpsLatitude: yup
    .number()
    .required('Max GPS latitude is required')
    .min(
      MIN_GPS_LATITUDE,
      `Max latitude must be greater than ${MIN_GPS_LATITUDE}`
    )
    .max(MAX_GPS_LATITUDE, `Max latitude must be less than ${MAX_GPS_LATITUDE}`)
    .test(
      'not-boundary-value',
      'GPS value at exact maximum boundary - possible sensor issue',
      (value) => !(Math.abs(value - MAX_GPS_LATITUDE) < GPS_BOUNDARY_TOLERANCE)
    ),

  maxGpsLongitude: yup
    .number()
    .required('Max GPS longitude is required')
    .min(
      MIN_GPS_LONGITUDE,
      `Max longitude must be greater than ${MIN_GPS_LONGITUDE}`
    )
    .max(
      MAX_GPS_LONGITUDE,
      `Max longitude must be less than ${MAX_GPS_LONGITUDE}`
    )
    .test(
      'not-boundary-value',
      'GPS value at exact maximum boundary - possible sensor issue',
      (value) => !(Math.abs(value - MAX_GPS_LONGITUDE) < GPS_BOUNDARY_TOLERANCE)
    ),

  fromDate: yupRequiredNonEmptyString('From date'),
  thruDate: yup.string().nullable(),
});

// Create TypeScript type from the schema
export type Alley = yup.InferType<typeof AlleySchema>;
